// extracted by mini-css-extract-plugin
module.exports = {"Reserve__cover":"Reserve_Reserve__cover__2HchH","Reserve__coverImage":"Reserve_Reserve__coverImage__3rPKe"};